require('unfetch')

const React = require('react')
// const Sentry = require('@sentry/browser');
const Layout = require('./src/components/Layout').default
const routeDuration = require('./src/components/Layout').TRANSITION_DURATION
const scrollToElement = require('scroll-to-element')

// Wrap every page with the main layout
exports.wrapPageElement = ({element, props}) => (
  <Layout {...props}>{element}</Layout>
)

// Delay updating scroll

exports.shouldUpdateScroll = ({prevRouterProps, routerProps}) => {
  if (!prevRouterProps) return
  if (routerProps.location.pathname !== prevRouterProps.location.pathname) {
    console.log('eee')
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, routeDuration)
  }

  return false
}

exports.onRouteUpdate = ({location}) => {
  checkHash(location)
}
const checkHash = location => {
  let {hash} = location
  if (hash) {
    setTimeout(() => {
      scrollToElement(hash, {
        duration: 1000,
      })
    }, 500)
  }
}

// Site Credit
console.log(`
Site Credit
===========
Development : https://patrickmccarthy.lol
Design : https://morganlight.com
`)
